import { cn } from 'utils/helpers';

export type GenericIconProps = React.SVGProps<SVGSVGElement>;

const attributes = {
  width: '100%',
  height: '100%',
  fill: 'currentColor',
  viewBox: '0 0 16 15',
  xmlns: 'http://www.w3.org/2000/svg',
};

const DEFAULT_STYLE = ['inline-block', 'text-secondary'];

type IconProps = Omit<React.SVGProps<SVGSVGElement>, 'path'> & {
  svg: React.SVGProps<SVGSVGElement>;
  path: { [key: string]: unknown }[];
  className: React.HTMLAttributes<HTMLDivElement>['className'];
};

const Icon: React.FC<IconProps> = ({ svg, path, className, ...props }) => {
  return (
    <div className={cn([DEFAULT_STYLE, className])}>
      <svg {...attributes} {...svg} {...props}>
        {path.map((pth) => {
          const pthAttr: { [key: string]: unknown } = {};

          const [key, value] = Object.entries(pth)[0];

          pthAttr[key] = value;

          return <path key={Math.random()} {...pthAttr} />;
        })}
      </svg>
    </div>
  );
};

export default Icon;
